import { FieldValues, useForm, UseFormProps, UseFormRegister } from 'react-hook-form';

// A secure version of react-hook-form's `useForm`, so that the results are safe to
// spread, since we control each of the key-value pairs of the returned object.
function useFormSecurely<
  TFieldValues extends FieldValues = FieldValues,
  TContext extends object = object,
>(props?: UseFormProps<TFieldValues, TContext>) {
  const {
    register,
    unregister,
    formState,
    watch,
    handleSubmit,
    reset,
    resetField,
    setError,
    clearErrors,
    setValue,
    setFocus,
    getFieldState,
    getValues,
    trigger,
    control,
  } = useForm<TFieldValues, TContext>(props);
  const wrappedRegister: UseFormRegister<TFieldValues> = (inputName, options?) => {
    // We drop any object properties that aren't explicitly named, so that we don't accidentally
    // spread a property named `dangerouslySetInnerHTML`.
    const { onChange, onBlur, ref, name } = register(inputName, options);
    return { onChange, onBlur, ref, name };
  };
  return {
    register: wrappedRegister,
    unregister,
    formState,
    watch,
    handleSubmit,
    reset,
    resetField,
    setError,
    clearErrors,
    setValue,
    setFocus,
    getFieldState,
    getValues,
    trigger,
    control,
  };
}

export { useFormSecurely };
